import React, {useEffect, useState} from 'react';
import {Form, Image, Spinner} from 'react-bootstrap';
import registerTFAF from '../images/Register-tfaf.png';
import HeaderTFAF from "./HeaderTFAF";
import ContinueOfflinePopupProspectFailed from "./ContinueOfflinePopupProspectFailed";
import RegisterFooterTFAF from "./RegisterFooterTFAF";

export default function Register() {


    return (<>
        <HeaderTFAF/>
        <div className="flex-container">
            {/* Left side */}
            <div className="lg-flex-left-side sm-flex-left-side">
                <div className="text-start" style={{textAlign: "center"}}>
                    <br/>
                    <br/>
                    <br/>
                    <div className="mediumTextStyles" style={{textAlign: "center"}}>Turners Friends & Family is now closed, but you can still purchase Autosure Mechanical Breakdown Insurance
                    </div>

                    <span style={{display: 'grid', justifyContent: 'center'}}>
                            <br/>
                    <button
                        onClick={() => window.location = "http://online.dplinsurance.co.nz/autosure/mbi"}
                        style={{
                            color: 'white',
                            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.05)',
                            borderRadius: 6,
                            paddingLeft: 25,
                            paddingRight: 25,
                            paddingTop: 13,
                            paddingBottom: 13,
                            overflow: 'hidden',
                            border: '1px white solid',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: "100%",
                            maxWidth: "200px",
                            background: '#0073CF',
                            cursor: 'pointer',
                        }}>Get quote</button></span>
                </div>
            </div>
            {/* Right side */}

        </div>
        <RegisterFooterTFAF/>
    </>);
}
